// @ts-nocheck
import { supabase } from './supabase';

async function triggerEmailSend(requestId: string): Promise<void> {
  try {
    await supabase.functions.invoke('send-email-summary', {
      body: { requestId },
    });
  } catch (err) {
    // Non-blocking — log but don't fail the capture flow
    console.warn('[emailCaptureService] Failed to trigger email send:', err);
  }
}

export interface EmailCaptureData {
  email: string;
  mainTopic?: string;
  subTopic?: string;
  coursesShown?: string[];
  conversationId?: string;
  conversationHistory?: any[];
  source: 'inline' | 'modal-comparison' | 'modal-recommendation';
}

export interface EmailCaptureResponse {
  success: boolean;
  error?: string;
  data?: any;
}

export const saveEmailCapture = async (
  data: EmailCaptureData
): Promise<EmailCaptureResponse> => {
  try {
    // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(data.email)) {
      return {
        success: false,
        error: 'כתובת המייל אינה תקינה',
      };
    }

    // Check if email already exists in recent requests (last 24 hours)
    const oneDayAgo = new Date();
    oneDayAgo.setDate(oneDayAgo.getDate() - 1);

    const { data: existingRequest } = await supabase
      .from('email_summary_requests')
      .select('id, email, created_at')
      .eq('email', data.email)
      .gte('created_at', oneDayAgo.toISOString())
      .maybeSingle();

    if (existingRequest) {
      // Re-trigger email if it was never sent
      if (existingRequest.status !== 'sent') {
        void triggerEmailSend(existingRequest.id);
      }
      return {
        success: true,
        data: existingRequest,
      };
    }

    // Insert into email_summary_requests
    const { data: newRequest, error } = await supabase
      .from('email_summary_requests')
      .insert({
        email: data.email,
        main_topic: data.mainTopic || null,
        sub_topic: data.subTopic || null,
        courses_shown: data.coursesShown || [],
        conversation_id: data.conversationId || null,
        conversation_history: data.conversationHistory || [],
        source: data.source,
        status: 'pending',
      })
      .select()
      .single();

    if (error) {
      console.error('Error saving email capture:', error);
      return {
        success: false,
        error: 'שגיאה בשמירת המידע. אנא נסה שוב.',
      };
    }

    // Also save to leads table
    try {
      await supabase.from('leads').insert({
        email: data.email,
        full_name: 'לא צוין',
        phone: '0000000000',
        message: `בקשה למידע נוסף - ${data.mainTopic || 'כללי'}`,
        source: data.source,
        status: 'new',
      });
    } catch (leadError) {
      // Non-blocking - log but don't fail the main flow
      console.warn('[emailCaptureService] Failed to save to leads table:', leadError);
    }

    // Trigger email send asynchronously (non-blocking)
    if (newRequest?.id) {
      void triggerEmailSend(newRequest.id);
    }

    return {
      success: true,
      data: newRequest,
    };
  } catch (error) {
    console.error('Exception in saveEmailCapture:', error);
    return {
      success: false,
      error: 'אירעה שגיאה. אנא נסה שוב מאוחר יותר.',
    };
  }
};

export const checkEmailExists = async (
  email: string
): Promise<boolean> => {
  try {
    const { data } = await supabase
      .from('email_summary_requests')
      .select('id')
      .eq('email', email)
      .maybeSingle();

    return !!data;
  } catch (error) {
    console.error('Error checking email:', error);
    return false;
  }
};
